const mutations = {
  SET_DATA(state, { key, data }) {
    state[key] = data;
  },
};

export default mutations;
